import React from 'react'
import Svg, { Path } from 'react-native-svg'

type Props = {
  color: string
  width?: number
  height?: number
}

/** Toolbar “Mark complete” control icon (22×20, stroke only). */
export function MarkCompleteToolbarIcon({ color, width = 22, height = 20 }: Props) {
  return (
    <Svg width={width} height={height} viewBox="0 0 22 20" fill="none">
      <Path
        d="M11.7901 0.900024V5.25602C4.62993 6.37552 1.96733 12.6482 0.900107 18.324C0.859814 18.5484 6.76328 11.8314 11.7901 11.79V16.146L20.5021 8.52302L11.7901 0.900024Z"
        stroke={color}
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
